import VerifyDevice from 'features/otp/challenges/VerifyDevice/VerifyDevice';
import React from 'react';

export default function VerifyDevicePage() {
  return <VerifyDevice />;
}
